import { AbstractDataClass, column } from '@/helpers/AbstractDataClass';

export interface Smart {
  _id?: string;
  code?: string;
  protocol?: string;
  mac?: string;
  https?: string;
  http?: string;
  name?: string;
  enabled?: boolean;
  phoneNumber?: string;
}

export interface SmartState {
  smart?: Smart;
  dataDevices?: DataDevice[];
}

export class DataDevice extends AbstractDataClass<DataDevice> implements Smart {
  public _id: string;

  @column({ label: 'Adresse Mac', isReadOnly: true, isSearchable: true })
  public mac?: string;

  @column({
    label: 'Nom',
    isReadOnly: false,
    placeholder: 'Nom du Smart Tx',
    isSearchable: true,
  })
  public name?: string;

  @column({
    label: 'Numéro Tél.',
    isReadOnly: true,
    placeholder: 'Num Tél. SIM',
  })
  public phoneNumber?: string;

  @column({
    label: 'Code',
    isReadOnly: false,
    placeholder: 'Code du Smart Tx',
  })
  public code?: string;

  @column({
    label: 'Activé',
    isReadOnly: false,
    isCheckbox: true,
    isSearchable: false,
  })
  public enabled?: boolean;

  static fromJSON(object: Smart): DataDevice {
    let dataDevice = new DataDevice();
    dataDevice = Object.assign(dataDevice, object);
    return dataDevice;
  }
}
